import { requestWithToken } from "../helper/helper";

const addImpactStory = async (payload) => {
  try {
    const response = await requestWithToken(
      "POST",
      `/admin/impact-story`,
      payload
    );

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

const fetchImpactStoryList = async (page, limit, lang) => {
  try {
    const queryParams = [];
    if (page) queryParams.push(`pageNo=${page}`);
    if (limit) queryParams.push(`pageSize=${limit}`);
    if (lang) queryParams.push(`lang=${lang}`);
    // Join the query parameters
    const queryString =
      queryParams.length > 0 ? `?${queryParams.join("&")}` : "";

    const response = await requestWithToken(
      "GET",
      `/admin/impact-story/list${queryString}`
    );

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

const editImpactStory = async (id, payload) => {
  try {
    const response = await requestWithToken(
      "PUT",
      `/admin/impact-story/${id}`,
      payload
    );

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

const getImpactStoryDetails = async (id) => {
  try {
    const response = await requestWithToken(
      "GET",
      `/admin/impact-story/details/${id}`
    );

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

const deleteImpactStory = async (id) => {
  try {
    const response = await requestWithToken(
      "DELETE",
      `/admin/impact-story/${id}`
    );

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

export {
  addImpactStory,
  fetchImpactStoryList,
  editImpactStory,
  getImpactStoryDetails,
  deleteImpactStory,
};
